import ERROR_CODES from './errorCodes';

export default (
  key,
  widgetId = 'TmtHakuWidgets',
  traceId,
  response,
  errorCode = ERROR_CODES.GENERAL
) => ({
  key,
  ...response,
  widgetId,
  traceId,
  internalErrorCode: errorCode
});
